import { Box, Flex } from "@jewlr/storybook/core"

const Loading = () => {
  return (
    <Flex justifyContent="center" minHeight="250px">
      <Box
        as="img"
        height="175"
        my="auto"
        src={require("images/layout/loadinglarge.gif")}
        width="175"
      />
    </Flex>
  )
}

export default Loading
